<template>
  <div ref="el">
    <div class="configurable-node-header">
      <p v-if="fieldData.name" class="configurable-node-header__title mb-0">
        {{ fieldData.name }}
      </p>
      <p v-else class="configurable-node-header__title mb-0">
        {{ $t('commands.selectable.selectField') }}
      </p>
      <div class="config-icon" @click="openConfigModal()">
        <feather-icon icon="SettingsIcon" size="16"/>
      </div>
    </div>
    <question-config-modal
      :idModal="idModal"
      :fieldData="fieldData"
      :fieldType="fieldType"
      :fieldTypes="fieldTypes"
      @show-preview="showPreviewField"
    />
  </div>
</template>

<script>
import nodeMixin from "@/mixins/nodeMixin";
import {ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import InputField from "./InputField.vue";
import OptionsField from "./OptionsField.vue";
import QuestionConfigModal from "./QuestionConfigModal.vue";
import {v4 as uuid} from "uuid";

export default {
  mixins: [nodeMixin],
  components: {
    InputField,
    OptionsField,
    QuestionConfigModal,
    ValidationProvider,
    vSelect
  },
  async mounted() {
    await this.$nextTick();
    this.getNodeId();
    this.getNodeData();

    if (this.nodeData.data.config) {
      const {config} = this.nodeData.data;

      this.setFieldDataFromConfig(config);
    }
  },
  data() {
    return {
      fieldData: {
        type: null,
        name: null,
        options: [],
        rules: null,
      },
      fieldType: null,
      fieldTypes: [
        'Checkbox',
        'Input',
        'Select',
        'Textarea'
      ],
      fieldTypesComponents: {
        'Checkbox': OptionsField,
        'Input': InputField,
        'Select': OptionsField,
        'Textarea': InputField
      },
      idModal: uuid(),
    }
  },
  methods: {
    setFieldType(fieldType) {
      this.fieldData.type = fieldType;
      this.fieldType = fieldType;

      if (fieldType === 'Input' || fieldType === 'Textarea') {
        this.fieldData.options = [];
      }
    },
    showPreviewField(fieldData) {
      this.fieldData = JSON.parse(JSON.stringify(fieldData));
      this.fieldType = this.fieldData.type;
      this.updateNodeData({
        config: {
          question: this.fieldData.name,
          type: this.fieldData.type,
          options: this.fieldData.options,
          rules: this.fieldData.rules,
        },
      });
    },
    openConfigModal() {
      this.$root.$bvModal.show(`selectable-config-modal-${this.idModal}`);
    },
    setFieldDataFromConfig(config) {
      const {type, question, options, rules} = config;

      this.fieldData = {
        type,
        name: question,
        options,
        rules,
      }

      this.fieldType = type;
    }
  }
}
</script>
